// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GoogleChromeLogoBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 2.5A13.5 13.5 0 1 0 29.5 16 13.515 13.515 0 0 0 16 2.5Zm0 3a10.487 10.487 0 0 1 8.238 4H16a6.506 6.506 0 0 0-5.769 3.509L8.023 9.184A10.478 10.478 0 0 1 16 5.5ZM19.5 16a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-14 0c0-1.332.254-2.652.75-3.889l4.125 7.139c.008.014.018.025.025.038a6.5 6.5 0 0 0 5.893 3.204l-2.21 3.83A10.515 10.515 0 0 1 5.5 16Zm12.006 10.39 4.119-7.14c.011-.019.02-.038.03-.058a6.476 6.476 0 0 0-.183-6.692h4.425a10.494 10.494 0 0 1-8.39 13.89Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
